module.exports = __webpack_public_path__ + "Trip-Cancellation-gray.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/Trip-Cancellation-gray.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/Trip-Cancellation-gray.png
// module chunks = 7